<template>
  <div 
    class="tool-remove text-hover-blue cursor-pointer" 
    :title="$t('engine.floatframeTool.btnHover.tooltip.lblRemove', languageEngine)" 
    v-b-tooltip.hover 
    @click="$emit('click')"
  >
    <span>
      <i class="far fa-trash-alt fs-14"></i>
    </span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
  },
}
</script>

<style>

</style>